function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var companyCache = {};
export default function CachePromise(authState) {
  return function (name, fn) {
    // pull the company id from the context
    var company_id = authState.claims.company_id; // if the company doesn't have a cache yet, make it

    if (!companyCache[company_id]) {
      companyCache[company_id] = {};
    } // get the company cache


    var promiseCache = companyCache[company_id]; // if the function has been run return the existing promise
    // otherwise run the function and return the result

    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!promiseCache[name]) {
                promiseCache[name] = fn();
              }

              return _context.abrupt("return", promiseCache[name]);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
}
//# sourceMappingURL=promise-cache.js.map